module.exports = __webpack_public_path__ + "img/foreward_3.1095b545.jpg";